import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueCookies from 'vue-cookies'
import store from './store'
import Snotify, {SnotifyPosition} from 'vue-snotify';


Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueCookies)
const options = {
	toast: {
		position: SnotifyPosition.centerCenter
	}
}
Vue.use(Snotify, options)

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

const axios = require('axios');

new Vue({
	router,
	render: h => h(App),
	store: store,
	data(){
		return {
			info: null
		}
	},
	beforeMount(){
		console.info("Se ejecuta el montaje de la APP");
		if (!$cookies.isKey('ctoken')) {
			console.info("No hay token, se busca crearlo");
			this.getCToken();
		}else{
			console.info("Ya existe la cookie");
		}
	},
	beforeCreate(){
		this.$store.commit('initialiseStore');
		this.$store.commit('finishStoreSubscription');
		//this.$store.commit('finishStore');
	},
	methods: {
		getCToken: function(){
			axios({
				method: 'POST',
				url: process.env.VUE_APP_API_ROUTE,
				data: {
					grant_type: 'client_credentials',
					client_id: process.env.VUE_APP_API_CLIENT,
					client_secret: process.env.VUE_APP_API_SECRET
				},
				headers: {'Content-Type': 'application/json'}
			})
			.then(response => {
				this.info = response
				//$cookies.set('ctoken', this.info.data.access_token, this.info.data.expires_in, '/', null, true, 'Lax');
				$cookies.set('ctoken', this.info.data.access_token, this.info.data.expires_in);
				console.info('Se obtuvo el token');
				console.info('Recargando la pagina');
				this.$store.commit('finishStoreSubscription');
				window.location.reload();
			})
			.catch(error => {
				console.error(error);
			});
		}
	},
	watch:{
		$route(to, from){
			if(to.name != "checkoutSubscription" && to.name != "guestCheckoutSubscriptions"){
				console.log('limpia suscripciones');
				this.$store.commit('finishStoreSubscription');
			}
		}
	}
}).$mount('#app')
